export enum FeatureFlag {
  DEFAULT = 'default',
  APP_V2_ENABLE_LLM_PIPELINE = 'app-v2-enable-LLM-Pipeline',
  GOOGLE_SHEETS_INTEGRATION = 'google-sheets-integration',
  FRESHDESK_INTEGRATION = 'freshdesk-integration',
  FRESHDESK_INTEGRATION_ENPAL = 'freshdesk-integration-enpal',
  CUSTOM_CODE_ACTION = 'custom-code-action',
  CUSTOM_CODE_LIVE_EDITOR = 'custom-code-live-editor',
  DUPLICATE_FLOW = 'duplicate-flow',
  CANVAS_NODE_ID = 'canvas-node-id',
  OUTLOOK_INTEGRATION_V1 = 'outlook-integration-v1',
  GW_INTEGRATION = 'gw-world-integration',
  FLOW_RUNS = 'flow-runs',
  RENAME_NODES = 'rename-nodes',
  FLOW_RUNS_DEV_TOOLS = 'flow-runs-dev-tools',
  MICROSOFT_ENTRA = 'microsoft-entra',
  HTTPS_CONTINUE_ON_ERROR = 'https-continue-on-error',
}

export type FeatureFlagsType = {
  [value in FeatureFlag]?: boolean | string;
};

export interface FeatureFlagReturnValue {
  flagValue: boolean | string | undefined;
  isLoading: boolean;
}

export interface FeatureFlagsContextProps {
  featureFlags: FeatureFlagsType | null;
  setFeatureFlags: (flags: FeatureFlagsType) => void;
}

export interface FeatureFlagsProviderProps {
  children: React.ReactNode;
}
